module.exports = __webpack_public_path__ + "img/181.0c053538.jpg";